import React, { FC } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'
import OverAll from './components/OverAll';
import BookingDetails from './components/BookingDetails';
import AddGuestInfo from './components/AddGuestInfo';
import ModifyDates from './components/ModifyDates';
import AddOns from './components/AddOns';
import CancelGroupBooking from './components/CancelGroupBooking';
import GuestInformation from './components/GuestInformation';
import ModifyRoomType from './components/ModifyRomeType';

const AccountContent: FC = () => {

  return (
    <Switch>

      {/* Redirects from old CamelCase routes */}
      <Redirect
        from="/account/bookings/addGuestInfo/:groupId/:roomId"
        to="/account/bookings/add-guest-info/:groupId/:roomId"
      />
      <Redirect
        from="/account/bookings/editGuestInfo/:groupId/:roomId"
        to="/account/bookings/edit-guest-info/:groupId/:roomId"
      />
      <Redirect
        from="/account/bookings/modifyDates/:groupId/:bookingId"
        to="/account/bookings/modify-dates/:groupId/:bookingId"
      />
      <Redirect
        from="/account/bookings/addOns/:groupId/:bookingId"
        to="/account/bookings/add-ons/:groupId/:bookingId"
      />
      <Redirect
        from="/account/bookings/GuestInformation/:groupId"
        to="/account/bookings/guest-information/:groupId"
      />
      <Redirect
        from="/account/bookings/CancelGroupBooking/:groupId"
        to="/account/bookings/cancel-group-booking/:groupId"
      />


      {/* New kebab-case routes */}
      <Route
        exact
        path="/account/bookings/add-guest-info/:groupId/:roomId"
        render={() => <AddGuestInfo />}
      />
      <Route
        exact
        path="/account/bookings/edit-guest-info/:groupId/:roomId"
        render={() => <AddGuestInfo />}
      />
      <Route
        exact
        path="/account/bookings/modify-dates/:groupId/:bookingId"
        render={() => <ModifyDates />}
      />
      <Route
        exact
        path="/account/bookings/modify-room-type/:groupId/:bookingId/:roomId"
        render={() => <ModifyRoomType />}
      />
      <Route
        exact
        path="/account/bookings/add-ons/:groupId/:bookingId"
        render={() => <AddOns />}
      />
      <Route
        exact
        path="/account/bookings/guest-information/:groupId"
        render={() => <GuestInformation />}
      />
      <Route
        exact
        path="/account/bookings/cancel-group-booking/:groupId"
        render={() => <CancelGroupBooking />}
      />
      <Route
        exact
        path="/account/bookings/:groupId"
        render={() => <BookingDetails />}
      />
      <Route
        exact
        path="/account/bookings/"
        render={() => <OverAll />}
      />


      {/* Default fallback */}
      <Redirect to="/account/bookings" />

      {/* <Route path={'/account/bookings/addGuestInfo/:groupId/:roomId'} render={() => <AddGuestInfo />} />
      <Route path={'/account/bookings/editGuestInfo/:groupId/:roomId'} render={() => <AddGuestInfo />} />
      <Route path={'/account/bookings/modifyDates/:groupId/:bookingId'} render={() => <ModifyDates />} />
      <Route path={'/account/bookings/addOns/:groupId/:bookingId'} render={() => <AddOns />} />
      <Route path={'/account/bookings/GuestInformation/:groupId/'} render={() => <GuestInformation />} />
      <Route path={'/account/bookings/CancelGroupBooking/:groupId'} render={() => <CancelGroupBooking />} />
      <Route path={'/account/bookings/:groupId'} render={() => <BookingDetails />} />
      <Route path={'/account/bookings/'} render={() => <OverAll />} />
      <Redirect to={'/account/bookings'} /> */}
    </Switch>
  );
};

export default AccountContent;